import { createHashHistory, History } from 'history'
import config from "../config";
const history: History = createHashHistory({
  // basename: config.basename,
})
export default history